// extracted by mini-css-extract-plugin
module.exports = {"UserInformationContentWrapper":"UserTerms_UserInformationContentWrapper__3NEwv","BuyTerms":"UserTerms_BuyTerms__1TGf8"};